module.exports = __webpack_public_path__ + "img/default-1.85c50b22.png";